import React from 'react';
import { Select } from './Select';
import type { SelectOption } from '../../types';

interface Props {
  className?: string;
  clearable?: boolean;
  name?: string;
  onChange: (value: SelectOption | null) => void;
  options: readonly SelectOption[];
  placeholder?: string;
  value?: SelectOption;
  sort?: boolean;
}

export const MatchColumnSelect = ({
  className,
  clearable,
  name,
  onChange,
  options,
  placeholder,
  value,
  sort
}: Props) => {
  return (
    <Select
      className={className}
      clearable={clearable}
      name={name}
      onChange={onChange}
      options={options}
      placeholder={placeholder}
      value={value || null}
      sort={sort}
    />
  );
};
